import { createStyles } from '@material-ui/core';

export default (theme) =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`,
      borderBottom: `1px solid ${theme.palette.divider}`,
      // media query for responsiveness
      '@media (max-width: 900px)': {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5)
      }
    },
    rootResponsive: {
      position: 'fixed',
      bottom: 0,
      zIndex: 1299
    },
    hangUpBtn: {
      backgroundColor: theme.palette.error.main,
      color: 'white',
      '&:hover': {
        backgroundColor: theme.palette.error.dark
      }
    },
    btnControl: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      [theme.breakpoints.down(400)]: {
        marginLeft: 2,
        marginRight: 2
      }
    }
  });
